import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { YoutubeVideo } from '@rotaryintl/harris-video';

const MyYoutubeVideo = ({ sitecoreContext, fields: { YoutubeId, Title } = {} }) => <YoutubeVideo youtubeId={YoutubeId?.value} title={Title?.value} />;
export default withSitecoreContext()(MyYoutubeVideo);
